export default __webpack_public_path__ + "static/media/a2.f10f2d00.svg";